import React, { useState, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX } = FiIcons;

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'About', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'AI Governance', href: '#ai-governance' },
    { name: 'Why Us', href: '#why-us' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-black/95 backdrop-blur-md shadow-lg shadow-black/40 py-3' : 'bg-transparent py-5'}`}>
      <div className="container mx-auto px-8 flex justify-between items-center">
        <a href="#" className="relative z-10 block">
          <img
            src="https://berqwp-cdn.sfo3.cdn.digitaloceanspaces.com/cache/minotaur-solutions.com/wp-content/uploads/2024/12/logo-0-e1733737765551.webp?bwp"
            alt="Minotaur Solutions"
            className="h-12 w-auto object-contain"
          />
        </a>
        <nav className="hidden md:flex items-center gap-8">
          <ul className="flex gap-8">
            {navLinks.map((link) => (
              <li key={link.name}>
                <a href={link.href} className="text-sm font-medium text-gray-300 hover:text-brand-orange transition-colors">
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
          <a href="#contact" className="btn-primary py-2.5 px-6 text-sm">Get Secured</a>
        </nav>
        <button className="md:hidden relative z-10 text-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          <SafeIcon icon={mobileMenuOpen ? FiX : FiMenu} className="text-2xl" />
        </button>
        <div className={`fixed inset-0 bg-black z-0 flex flex-col items-center justify-center transition-transform duration-300 ease-in-out ${mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'} md:hidden`}>
          <ul className="flex flex-col gap-8 text-center mb-8">
            {navLinks.map((link) => (
              <li key={link.name}>
                <a href={link.href} className="text-2xl font-semibold text-white hover:text-brand-orange" onClick={() => setMobileMenuOpen(false)}>
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
          <a href="#contact" className="btn-primary" onClick={() => setMobileMenuOpen(false)}>Get Secured</a>
        </div>
      </div>
    </header>
  );
}